<mat-toolbar class="mat-elevation-z1 p-0">
  <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start stretch">
    <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start stretch">
      <button
        mat-button
        class="h-full"
        *ngIf="!hiddenNavbar"
        (click)="toggleSidebarOpen('navbar')"
        fxHide.gt-md
      >
        <mat-icon class="secondary-text">menu</mat-icon>
      </button>

      <div class="toolbar-separator" *ngIf="!hiddenNavbar" fxHide.gt-md></div>

      <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
        <div class="logo ml-4">
          <img class="logo-icon" src="/assets/logo.png" />
        </div>
      </div>

      <div class="px-2 md:px-4 flex items-center">
        <fuse-shortcuts
          [navigation]="fuseNavMap.navigation$ | async"
        ></fuse-shortcuts>
      </div>
    </div>

    <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
      <ng-container *ngIf="authService.currentUser$ | async; let currentUser">
        <button
          *ngIf="currentUser.isAuthenticated; else loginBtn"
          mat-button
          [matMenuTriggerFor]="userMenu"
          class="user-button"
        >
          <div fxLayout="row" fxLayoutAlign="center center">
            <img class="avatar" src="assets/avatar.png" />
            <span class="username mx-2" fxHide fxShow.gt-sm>
              {{ currentUser?.userName }}
            </span>
            <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
          </div>
        </button>
        <ng-template #loginBtn>
          <button (click)="authService.login()" class="user-button" mat-button>
            {{ 'AbpAccount::Login' | abpLocalization }}
          </button>
        </ng-template>
      </ng-container>
      <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
        <a mat-menu-item routerLink="/account/manage-profile">
          {{ 'AbpAccount::MyAccount' | abpLocalization }}
        </a>

        <button mat-menu-item routerLink="/audit/identity">
          {{ 'AbpDz::SecurityLogs' | abpLocalization }}
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="logout()">
          {{ 'AbpUi::Logout' | abpLocalization }}
        </button>
      </mat-menu>

      <div class="toolbar-separator"></div>

      <abp-notification class="h-full"></abp-notification>
      <div class="toolbar-separator"></div>

      <div class="toolbar-separator" fxHide fxShow.gt-xs></div>
    </div>
  </div>
</mat-toolbar>
